module.exports = __webpack_public_path__ + "static/media/emily.e17f5231.jpg";